module.exports = __webpack_public_path__ + "static/img/2_2_2_3.35783acd.jpg";